'use strict'
import ViewBase from '../../../view-base.view'
import { Dialog } from 'construct-ui'
import languageModel from '../../../../models/language.model';
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import CVIterationImageDetailView from '../cvtrains/custom-vision-iteration-image-detail.view';
import paginationComponent from '../../../../components/pagination/pagination.component';

export default function CVIterationImagesListView() {
    ViewBase.call(this);

    let isPopupViewIterationImageOpened = false;

    let inputDataModel = { totalCount: 0, pageIndex: 1, pageSize: 9 };

    let selectedProjectId = 0;
    let selectedIterationId = 0;
    let selectedImageId  = 0;
    let iterationImages = [];

    let _loadIterationImages = () => {
        this.showLoading();

        trainModel.getIterationImagesList(
            (result) => {
                this.hideLoading();
                
                iterationImages = result.data;
                                
                if (result.data == null || (iterationImages.length == 1 && iterationImages[0].imageId == 0)) {
                    iterationImages = [];
                }

                inputDataModel.totalCount = result.total;
                inputDataModel.pageIndex = result.pageIndex;
                inputDataModel.pageSize = result.pageSize;

            }, (error) => {
                this.hideLoading();

                iterationImages = [];

                this.handleError(error);

            },
            selectedProjectId,
            selectedIterationId, 
            inputDataModel.pageIndex, inputDataModel.pageSize);
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadIterationImages();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadIterationImages();
    }

    let _viewIterationImage = (imageId) => {
        selectedImageId = imageId;
        isPopupViewIterationImageOpened = true;
    }

    let onPopupClose = (e) => { };

    let _cancel = (e) => {
        onPopupClose(e);
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.onPopupClose) {
                onPopupClose = vnode.attrs.onPopupClose;
            }
            if(vnode.attrs.projectId){
                selectedProjectId = vnode.attrs.projectId;
                selectedIterationId = vnode.attrs.iterationId;
                
                _loadIterationImages();
            }
        },
        view: ({ attrs }) => {
            
            return [
                m('.card.mb-3.mt-2', 
                    m('.card-body.py-3', 
                        m('.row', 
                            m('.container', [
                                m('div', { "class": "row" }, 
                                
                                    iterationImages.length == 0 &&
                                    m('span', this.getText("EM00000141", "No records found.")),
                                    
                                    iterationImages.length > 0 &&
                                    m(".col-md-12", m(".row", 
                                        [
                                            iterationImages.map(function (iterationImage, index) {
                
                                                let _hasRepresentivePicture = (iterationImage.fileContent != '' && iterationImage.fileContent != null);
                
                                                return _hasRepresentivePicture && m("div", { "class": "col-md-4", style: "margin-bottom: 24px;" },
                                                    [
                                                        m("img", { "src": iterationImage.fileContent, "style": "max-width: 100%; cursor: pointer;", onclick:()=>{ _viewIterationImage(iterationImage.imageId); } }),
                                                        m(".row", { style: "margin-top: 6px;" }, [
                                                            m(".col-8", [
                                                                m("div", [m("i", { "class": "bi bi-person" }), m("span",iterationImage.createUserName)]),
                                                                m("div", [m("i", { "class": "bi bi-clock" }), m("span",iterationImage.createDateDisplay)])
                                                            ]),
                                                            m(".col-4", m("button.btn.btn-white[type='button']", { onclick:()=>{ _viewIterationImage(iterationImage.imageId); }}, languageModel.getText("LT00000378", "View")))
                                                        ])
                                                    ]
                                                )
                                            })
                                        ]
                                    )),
                                    m(paginationComponent,
                                        {
                                            pageSizeChoise: [9, 18, 48, 99],
                                            currentPage: inputDataModel.pageIndex,
                                            pageSize: inputDataModel.pageSize,
                                            totalItems: inputDataModel.totalCount,
                                            onPageChanged: onPageChanged,
                                            onPageSizeChanged: onPageSizeChanged
                                        }
                                    )
                                )
                            ])
                        )
                    ),
                    m('.card-footer',
                        m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                            m("button.btn.btn-white[type='button']", { onclick: _cancel }, this.getText("LT00000021", "Close"))
                        )
                    ),
                    m(Dialog, {
                        isOpen: isPopupViewIterationImageOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupViewIterationImageOpened = false; },
                        title: this.getText("LT00000379", "Image Detail"),
                        content: m(CVIterationImageDetailView, { 
                            onPopupClose: ()=>{ isPopupViewIterationImageOpened = false },
                            projectId: selectedProjectId,
                            iterationId: selectedIterationId,
                            imageId: selectedImageId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                ),
                
                this.getBaseViews()
            ];
        },
    };
}
